export enum KeyboardStepMode {
	Amount = 'Amount',
	Percent = 'Percent'
}

/** Fixed overlay height — keep in sync with `.keyboard-overlay` in keyboard.component.scss */
export const KEYBOARD_HEIGHT_PX = 151;
